import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchRichTextCurrent = ({ entityType, entityId }) =>
  HttpClient().get(`/rich_texts/v1/${entityType}/${entityId}/current`)

const getRichTextCurrent = (params) => (dispatch) =>
  fetchRichTextCurrent(params)
    .then((response) => {
      if (response.status === 200) {
        dispatch(loadJsonApiEntities(response.data))
      }
      return response
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getRichTextCurrent
